<template>
    <div class="user-management-wrapper">
        <h2>Dealers</h2>
        <hr>
        <div class="user-management">
            <BasicDataGrid
                    :dataSource="dealers"
                    :multiSelect="false"
                    :columns="columns"
                    :showColumnLines="false"
                    :actions="actions"
                    v-on:editUsers="loadDealerUsers"
                    v-on:editDealer="loadDealerProfile"
            />
        </div>
    </div>
</template>

<script>
    import BasicDataGrid from '@/components/BasicDataGrid.vue';
    import { DealerService } from '@/services';
    export default {
        name: "DealerSearch",
        components: {
            BasicDataGrid,
        },
        data: () => {
            return {
                actions: [
                    {
                        hint: 'Dealer-Profile',
                        icon: 'edit',
                        emit: 'editDealer',
                    },
                    {
                        hint: 'User-Management',
                        icon: 'group',
                        emit: 'editUsers',
                    },
                ],
                customerStatusOptions: [{text: 'Private', value: 'private'}, {text: 'Global', value: 'global'}],
                columns: [
                    {text: 'Dealer', value:'DisplayName'},
                ],
                dealers: []
            }
        },
        methods: {
            getDealers(){
                DealerService.all().then(res => {
                    this.dealers = res;
                }).catch(err => {
                    console.log(err);
                })
            },
            loadDealerUsers(e){
                let dealerId = e.row.data.Id;
                this.$router.push( { name: 'DealerUsers', params: { id: dealerId }});
            },
            loadDealerProfile(e){
                let dealerId = e.row.data.Id;
                this.$router.push( { name: 'DealerProfile', params: { id: dealerId }});
            }
        },
        mounted(){
            this.getDealers();
        }
    }
</script>

<style scoped>

</style>
